import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { ErrorMessage } from '@hookform/error-message';
import {
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Modal,
  ModalBody,
  Row
} from 'reactstrap';

import { buttonStyle } from 'components/Containers/ConfigurationContainer/components/utils';
import FlexSelect from 'components/Inputs/FlexSelect';
import QueueService from '../../../../../Queue/service';
import { removeAnsweredConversation } from 'store/action/answered-conversations-action';
import { removeConversationInAttendance } from 'store/action/conversation-in-attendance-action';
import { useSocketConversationChatTs } from '../../../../../../hooks/useSocketConversationChatTs';
import { useSocketLoggedAttendants } from '../../hooks/useSocketLoggedAttendants';
import { verifyRoles } from 'components/Authentication/VerifyRoles';
import { GrTransaction } from 'react-icons/gr';
import { SvgContainer } from '../styles';
import UserService from '../../../../../User/service';

import { hooks } from '../../../../../../hooks';

const TransferManyButton = ({
  tooltipTitle = '',
  id,
  setSelectedRows = () => {},
  isStringArray = false,
  altIcon = false,
  getConversations = () => {}
}) => {
  const { socketChatTS, emitEventTransferMultipleChatsToQueue } =
    useSocketConversationChatTs();
  const { getQueuesChat } = hooks.useQueueContentChatContext();

  const { loggedAttendants } = useSocketLoggedAttendants();

  const { control, handleSubmit, errors, setValue } = useForm();
  const [isOpen, setIsOpen] = useState(false);
  const [queues, setQueues] = useState([]);
  const [queueIdSelected, setQueueIdSelected] = useState();
  const [isTransferByAgentEspecific, setInsTransferByAgentEspecific] =
    useState(false);
  const systemConfiguration = useSelector((state) => state.systemConfiguration);
  const [showUserOff, setShowUserOff] = useState(false);
  const [transferToSelf, setTransferToSelf] = useState(false);
  const [
    isCurrentAgentsLoggedWithoutTheCurrentAgent,
    setIsCurrentAgentsLoggedWithoutTheCurrentAgent
  ] = useState([]);
  const [
    isCurrentAgentsLoggedWithTheCurrentAgent,
    setIsCurrentAgentsLoggedWithTheCurrentAgent
  ] = useState([]);

  useEffect(() => {
    if (isOpen) {
      getQueuesChat()
        .then((response) => {
          setQueues([...response]);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [isOpen]);

  useEffect(() => {
    if (isTransferByAgentEspecific) {
      if (loggedAttendants) {
        const agentsWithoutCurrentAgent = loggedAttendants.filter(
          (agent) => agent.login !== localStorage.getItem('login')
        );
        setIsCurrentAgentsLoggedWithoutTheCurrentAgent(
          agentsWithoutCurrentAgent
        );
      }
    } else if (transferToSelf) {
      if (loggedAttendants) {
        const agentsWithCurrentAgent = loggedAttendants.filter(
          (agent) => agent.login === localStorage.getItem('login')
        );
        setIsCurrentAgentsLoggedWithTheCurrentAgent(agentsWithCurrentAgent);
      }
    }
  }, [loggedAttendants, isTransferByAgentEspecific, transferToSelf]);

  useEffect(() => {
    if (isTransferByAgentEspecific) {
      UserService.getAll()
        .then((response) => {
          const res = response.data.data;
          const usersSort = res
            .sort((a, b) => {
              if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
              if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
              return 0;
            })
            .filter((agent) => agent.login !== localStorage.getItem('login'));

          if (!showUserOff) {
            const agentsWithoutCurrentAgent = loggedAttendants.filter(
              (agent) => agent.login !== localStorage.getItem('login')
            );
            setIsCurrentAgentsLoggedWithoutTheCurrentAgent(
              agentsWithoutCurrentAgent
            );
          } else {
            setIsCurrentAgentsLoggedWithoutTheCurrentAgent(usersSort);
          }
        })
        .catch((err) => {
          console.log(err);
          const message = 'Erro ao carregar usuários';
          toast.error(message, {
            autoClose: 3000,
            closeOnClick: true
          });
        });
    }
  }, [showUserOff]);

  const toggleModal = () => {
    setIsOpen(!isOpen);
  };

  const onSubmit = async (data) => {
    const info = isStringArray
      ? id
      : id.map((item) => item['_id'] || item['id'] || item);

    try {
      if (isTransferByAgentEspecific) {
        let atendente;
        let agentFilter = {};

        if (transferToSelf) {
          agentFilter = isCurrentAgentsLoggedWithTheCurrentAgent.find(
            (agent) => agent.login === localStorage.getItem('login')
          );
          atendente = {
            name: agentFilter?.name || localStorage.getItem('name'),
            login: agentFilter?.login || localStorage.getItem('login'),
            id_socket_atendente: agentFilter?.socket_id || ''
          };
        } else {
          agentFilter = isCurrentAgentsLoggedWithoutTheCurrentAgent.find(
            (agent) => data?.user === agent.login
          );

          atendente = {
            name: agentFilter.name,
            login: agentFilter.login,
            id_socket_atendente: agentFilter.socket_id
          };
        }

        socketChatTS.emit('transferir_multiplas_conversas_atendente', {
          ids: info,
          atendente,
          responsavelPelaTransferencia: {
            name: localStorage.getItem('name'),
            login: localStorage.getItem('login')
          }
        });
      } else {
        emitEventTransferMultipleChatsToQueue({
          chatIds: info,
          queueId: queueIdSelected,
          subject: data?.assunto,
          observation: data?.observacao,
          sector: data?.setor
        });
      }
      setSelectedRows([]);
      setTimeout(() => {
        getConversations();
      }, 20 * 1000);
      toggleModal();
    } catch (err) {
      console.log('err: ', err);
      toast.error('Erro ao transferir conversa!', {
        autoClose: 3000,
        closeOnClick: true
      });
    }
  };

  const errorFormMessage = (message) => (
    <p style={{ color: 'red' }}>{message}</p>
  );

  return (
    <>
      {altIcon
        ? verifyRoles(['CHAT_MULTIPLE_TRANSFER']) && (
            <Button
              size="sm"
              color="link"
              title={tooltipTitle}
              onClick={toggleModal}
              disabled={!id.length}
              style={{
                minHeight: '46px',
                background: 'none',
                border: 'none',
                color: systemConfiguration.primary_color,
                paddingBottom: '6px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <SvgContainer color={systemConfiguration.primary_color}>
                <GrTransaction
                  style={{
                    stroke: 'blue'
                  }}
                  size="20"
                  title="Transferir múltiplas conversas"
                />
              </SvgContainer>
            </Button>
          )
        : verifyRoles(['CHAT_TRANSFERS']) && (
            <Button
              size="sm"
              color="primary"
              title={tooltipTitle}
              onClick={toggleModal}
              disabled={!id.length}
              style={{ minHeight: '46px' }}
            >
              Transferir várias
            </Button>
          )}
      <Modal
        className="modal-dialog-centered"
        isOpen={isOpen}
        toggle={toggleModal}
      >
        <div className="modal-header">
          <h6 className="modal-title" id="modal-title-default">
            {`Transferir conversas`}
          </h6>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={toggleModal}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <ModalBody>
          <hr style={{ marginTop: '-35px' }} />
          <Form className="needs-validation" onSubmit={handleSubmit(onSubmit)}>
            <Row className="mb-3">
              <Col md="12">
                <FormGroup check>
                  <Input
                    type="checkbox"
                    checked={isTransferByAgentEspecific}
                    onChange={() =>
                      setInsTransferByAgentEspecific(
                        !isTransferByAgentEspecific
                      )
                    }
                  />
                  <label className="form-control-label">
                    Trocar forma de transferência para atendente específico
                  </label>
                </FormGroup>
              </Col>
            </Row>
            {!isTransferByAgentEspecific ? (
              <Row className="mb-3">
                <Col md="12">
                  <label className="form-control-label">Fila*</label>
                  <Controller
                    render={(props) => (
                      <FlexSelect
                        dataOptions={queues}
                        isMulti={false}
                        isClearable={false}
                        value={props.value}
                        valueController={setValue}
                        closeMenuOnSelect={true}
                        isSearchable={true}
                        fieldName="fila"
                        labelName="name"
                        valueName="name"
                        onChange={(e) => {
                          const queue = queues.find((q) => q.name === e)?.id;
                          setQueueIdSelected(queue);
                        }}
                      />
                    )}
                    control={control}
                    name="fila"
                    defaultValue=""
                    rules={{ required: 'A fila é obrigatória' }}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="fila"
                    render={({ message }) => errorFormMessage(message)}
                  />
                </Col>
              </Row>
            ) : (
              <>
                <Row className="mb-3">
                  <Col md="12">
                    <FormGroup check>
                      <Input
                        type="checkbox"
                        checked={showUserOff}
                        onChange={() => setShowUserOff(!showUserOff)}
                      />
                      <label className="form-control-label">
                        Mostrar Usuários Deslogados
                      </label>
                    </FormGroup>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md="12">
                    <FormGroup check>
                      <Input
                        type="checkbox"
                        checked={transferToSelf}
                        onChange={() => setTransferToSelf(!transferToSelf)}
                      />
                      <label className="form-control-label">
                        Transferir para si mesmo
                      </label>
                    </FormGroup>
                  </Col>
                </Row>
                {!transferToSelf && (
                  <Row className="mb-3">
                    <Col md="12">
                      <label className="form-control-label">Usuário*</label>
                      <Controller
                        render={(props) => (
                          <FlexSelect
                            dataOptions={
                              isCurrentAgentsLoggedWithoutTheCurrentAgent
                            }
                            isMulti={false}
                            isClearable={true}
                            value={props.value}
                            valueController={setValue}
                            closeMenuOnSelect={true}
                            isSearchable={true}
                            fieldName="user"
                            labelName="name"
                            valueName="login"
                          />
                        )}
                        control={control}
                        name="user"
                        defaultValue=""
                        rules={{ required: 'Usuário é obrigatório!' }}
                      />
                      <ErrorMessage
                        errors={errors}
                        name="user"
                        render={({ message }) => errorFormMessage(message)}
                      />
                    </Col>
                  </Row>
                )}
              </>
            )}

            <Button
              color="danger"
              data-dismiss="modal"
              type="button"
              onClick={toggleModal}
              style={buttonStyle(systemConfiguration.cancelation_button_color)}
            >
              Fechar
            </Button>

            <Button
              color="primary"
              type="submit"
              style={buttonStyle(systemConfiguration.confirmation_button_color)}
            >
              {transferToSelf ? 'Transferir para si mesmo' : 'Transferir'}
            </Button>
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};

export default TransferManyButton;
